// JS Utils
export function getMobileOperatingSystem() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  const isAndroid = /android/i.test(userAgent)
  const isIOS = /iPhone|iPod/.test(userAgent) && !window.MSStream

  if (isAndroid) {
    return 'android'
  }

  if (isIOS) {
    return 'iOS'
  }

  return 'desktop'
}

export function isDeviceMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera

  const isAndroid = /android/i.test(userAgent)
  const isIOS = /iPhone|iPod/.test(userAgent) && !window.MSStream

  return isAndroid || isIOS
}
